import { lazy } from 'react';

const UsersPage = lazy(() => import('./pages/UsersPage'));

export const UsersEntry = () => <UsersPage />;
